import React from 'react';
import { Timeline } from 'antd';

const Home = () => (
  <div className="aligner">
    <div className="aligner-item">
      <Timeline pending="Developing...">
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          A new platform have been developed with a modern design using cutting-edge web development technologies such
          as Node JS(backend) - React JS(frontend). 2018 - 07 - 18
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          User can select different sets of POI(up to 5) to visualize the results. 2018 - 07 - 25
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          Custom input selection has been added additionally to current ARP(hazard map) and PoE(probability map) values
          which give to a user freedom to generate custom maps. 2018 - 08 - 02
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          2nd and 98th percentiles have been added to statistics. 2018 - 08 - 04
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          Downloading the hazard curves all at once is possible for selected POI set. 2018 - 08 - 13
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          Downloading the hazard maps all at once is possible for selected POI set. 2018 - 08 - 24
        </Timeline.Item>
        <Timeline.Item
          style={{
            fontSize: 14,
          }}
        >
          Initial feedbacks have been completed. 2019 - 02 - 18
        </Timeline.Item>
      </Timeline>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home.js